import * as api from '@owl-nest/api-client/latest'

export function isPending(proposal: api.Proposal): boolean {
  return proposal.status === api.ProposalStatus.PENDING
}

export function isInvalid(proposal: api.Proposal): boolean {
  return [api.ProposalAnswerCode.INVALID_COUNTRY, api.ProposalAnswerCode.INVALID_OKPAL].includes(proposal.answer_code!)
}

export function isReady(proposal: api.Proposal): boolean {
  return Boolean(proposal.answer_code) && (isInvalid(proposal) || Boolean(proposal.project) || isPending(proposal))
}
